module.exports = __webpack_public_path__ + "img/hr-pipe-ending-left.ad28c237.png";